import { render, staticRenderFns } from "./narrow-search-feature-item.vue?vue&type=template&id=37283f64"
import script from "./narrow-search-feature-item.vue?vue&type=script&lang=js"
export * from "./narrow-search-feature-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports